import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';

export const NotFoundContainer = styled(Box)(({ theme }) => ({
  minHeight: '60vh',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(2),
}));
